<app-loading *ngIf="loading"></app-loading>

<div class="image-processing-wrapper" *ngIf="!loading">
  <div class="upload-section">
    <button mat-stroked-button type="button" (click)="fileInput.click()">
      <mat-icon>attach_file</mat-icon>
      <span>{{ 'employee.avatar.selectFile' | translate }}</span>
    </button>
    <input
      hidden
      type="file"
      #fileInput
      [attr.accept]="allowedFileExtensions.join(',')"
      (change)="onFileSelect($event)"
    >
  </div>

  <div class="main-content">
    <div *ngIf="localAvatar && !uploadedImage" class="thumbnail-wrapper">
      <img [src]="thumbnailPhotoUrl" class="thumbnail-image" alt="">
    </div>

    <div class="cropper-container" *ngIf="uploadedImage || finalImage">
      <div *ngIf="isImageCropperLoading" class="cropper-loader">
        <app-loading></app-loading>
      </div>
      <div *ngIf="!isImageCropperLoading" class="cropper-surface">
        <image-cropper
          [imageFile]="finalImage"
          [maintainAspectRatio]="true"
          [resizeToWidth]="360"
          [cropperMinWidth]="128"
          [onlyScaleDown]="true"
          [roundCropper]="false"
          [canvasRotation]="0"
          [alignImage]="'center'"
          [aspectRatio]="1"
          format="png"
          (imageCropped)="imageCropped($event)"
          [backgroundColor]="cropperBackgroundColor"
        ></image-cropper>
      </div>
    </div>

    <div class="settings-grid" *ngIf="uploadedImage">
      <div class="settings-section" *ngIf="!isImageTooLarge">
        <h4 class="block-title">{{ 'employee.avatar.backgroundSettings' | translate }}</h4>
        <div class="background-actions">
          <button mat-stroked-button type="button" (click)="drawAvatarWithColor('')">
            <mat-icon>texture</mat-icon>
            <span>{{ 'employee.avatar.transparent' | translate }}</span>
          </button>
          <button mat-stroked-button type="button" (click)="drawOriginalAvatar()">
            <mat-icon>undo</mat-icon>
            <span>{{ 'employee.avatar.original' | translate }}</span>
          </button>
          <button mat-stroked-button type="button" (click)="drawAvatarWithColor('black')">
            <mat-icon>lens</mat-icon>
            <span>{{ 'employee.avatar.black' | translate }}</span>
          </button>
          <button mat-stroked-button type="button" (click)="drawAvatarWithColor('white')">
            <mat-icon>panorama_fish_eye</mat-icon>
            <span>{{ 'employee.avatar.white' | translate }}</span>
          </button>
        </div>
        <mat-form-field appearance="outline" *ngIf="backgroundApplied">
          <mat-label>{{ 'employee.avatar.customColor' | translate }}</mat-label>
          <div matSuffix class="color-picker-wrapper">
            <input type="color" [value]="customBackgroundColor.value" (input)="onCustomColorChange($event)">
          </div>
          <input matInput type="text" [formControl]="customBackgroundColor" placeholder="#FFFFFF">
        </mat-form-field>
      </div>

      <div class="gif-personalization">
        <div
          class="dc-toggle-list dc-toggle-list--stacked"
          [class.dc-toggle-list--joins-next]="gifPersonalizationEnabled">
          <div class="dc-toggle-item">
            <mat-slide-toggle
              color="primary"
              class="dc-toggle-item__control"
              [(ngModel)]="gifPersonalizationEnabled"
              (ngModelChange)="onGifPersonalizationToggle($event)">
              {{ 'employee.avatar.enableGifPersonalization' | translate }}
            </mat-slide-toggle>
          </div>
        </div>

        <div class="dc-revealed-panel" *ngIf="gifPersonalizationEnabled">
          <div class="field-row">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'employee.avatar.borderColor' | translate }}</mat-label>
              <div matSuffix class="color-picker-wrapper">
                <input type="color" [value]="borderColorControl.value" (input)="onBorderColorChange($event)">
              </div>
              <input matInput type="text" [formControl]="borderColorControl" placeholder="#000000">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'employee.avatar.borderWidth' | translate }}</mat-label>
              <input matInput type="number" [formControl]="borderWidthControl" min="0" placeholder="10">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'employee.avatar.borderRadius' | translate }}</mat-label>
              <input matInput type="number" [formControl]="borderRadiusControl" min="0" max="50" placeholder="50">
            </mat-form-field>
          </div>

          <div class="dc-toggle-list dc-toggle-list--stacked">
            <div class="dc-toggle-item">
              <mat-slide-toggle
                color="primary"
                class="dc-toggle-item__control"
                [(ngModel)]="darkenEffect">
                {{ 'employee.avatar.darkenEffect' | translate }}
              </mat-slide-toggle>
            </div>
          </div>

          <div class="gif-actions">
            <button
              mat-stroked-button
              type="button"
              (click)="generatePulsatingBorderGif()"
              [disabled]="isGifGenerating || !croppedImage"
              [class.loading-button]="isGifGenerating">
              <mat-spinner diameter="20" class="dc-btn-spinner" *ngIf="isGifGenerating"></mat-spinner>
              <mat-icon *ngIf="!isGifGenerating">gif</mat-icon>
              <span *ngIf="!isGifGenerating">{{ 'employee.avatar.generateGif' | translate }}</span>
            </button>
          </div>

          <div class="gif-preview" *ngIf="isGifGenerating || gifDataUrl">
            <app-loading *ngIf="isGifGenerating"></app-loading>
            <img *ngIf="!isGifGenerating && gifDataUrl" [src]="gifDataUrl" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions-footer" *ngIf="uploadedImage">
    <button
      mat-raised-button
      type="button"
      color="primary"
      (click)="saveAvatar()"
      [class.loading-button]="isSaving"
      [disabled]="isSaving || !canSave">
      <mat-spinner diameter="20" class="dc-btn-spinner" *ngIf="isSaving"></mat-spinner>
      <mat-icon *ngIf="!isSaving">save</mat-icon>
      <span *ngIf="!isSaving">{{ 'employee.avatar.save' | translate }}</span>
    </button>
  </div>
</div>
